import { createLoaderImp } from '../../../components/ozmoit/common/loader-imp';
import { getFormDataAction } from '../actions';

const {
  useLoaderData: useWarningsSummaryFormLoaderData,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({
  action: getFormDataAction,
});

function StudentWarningsSummaryFormLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export { StudentWarningsSummaryFormLoader, useWarningsSummaryFormLoaderData };
